export const AXIOS_HEADER = {
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*"
};

export const CUCAT_WARANTY = "Waranty Furniture Repair";
export const CUCAT_FEEDBACK = "Site Feedback";
export const CUCAT_GENERAL = "General Inquiry";
export const CUCAT_ORDER = "Order Related Question";
